<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
    <template slot="outTimeRangeSearch" slot-scope="scope">
    <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.outTimeStart"
              type="date"
              value-format="yyyy-MM-dd 00:00:00"
              range-separator="到"
              placeholder="开始日期"
           
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.outTimeEnd"
              type="date"
              value-format="yyyy-MM-dd 23:59:59"
              range-separator="到"
            
              placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
      <template slot="inTimeRangeSearch" slot-scope="scope">
    <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.inTimeStart"
              type="date"
              value-format="yyyy-MM-dd 00:00:00"
              range-separator="到"
              placeholder="开始日期"
           
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.inTimeEnd"
              type="date"
              value-format="yyyy-MM-dd 23:59:59"
              range-separator="到"
            
              placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
      <template slot="payTimeRangeSearch" slot-scope="scope">
    <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.payTimeStart"
              type="date"
              default-time="00:00:00"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="到"
              placeholder="开始日期"
           
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.payTimeEnd"
              type="date"
              default-time="23:59:59"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="到"
            
              placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
      <template slot="parkingLotIdSearch">
        <selectSearch  v-model="parkingLotId" :dicData="parkingLotList"></selectSearch>
        <!-- <el-select v-model="parkingLotId">
          <el-option
            v-for="item in parkingLotList"
            :key="item"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select> -->
      </template>

      <template slot="minMoneySearch">
        <div>
<el-input v-model="minMoney" style="width:46%;" maxlength="4" type="number"></el-input>
<span style="width:8%;display:inline-block;">至</span>
<el-input v-model="maxMoney" style="width:46%;" maxlength="4" type="number"></el-input>
        </div>
      </template>

      <template slot="chargeTotalSumSearch">
<el-input v-model="chargeTotalSum" disabled></el-input>
      </template>
      <template slot="chargeAmountSumSearch">
<el-input v-model="chargeAmountSum" disabled></el-input>
      </template>


      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.tempcarbill_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/car/tempcarbill';
import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {
        outTimeStart:'',
        outTimeEnd:'',
        inTimeStart:'',
        inTimeEnd:'',
        payTimeStart:'',
        payTimeEnd:''
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      parkingLotId: '',
      parkingLotList: [],
      chargeTotalSum:'0',
      chargeAmountSum:'0',
      minMoney:'',
      maxMoney:'',
      option: {
        headerAlign:'left',
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 12,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: false,
        menu: false,
        columnBtn: false,
        dialogClickModal: false,
        align: 'left',
        refreshBtn:false,
        column: [
          {
            label: '车场',
            prop: 'parkingLotId',
            width: 120,
            type: 'select',
            search: true,
            searchslot:true,
            hide: true,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
          },
          {
            label: '支付编号',
            search: true,
            prop: 'payNo',
            width: 170,
            overHidden: true,
            defaultSort:{
              prop: 'name',
              order: 'descending'
            },
          },
          {
            label: '车牌号',
            search: true,
            prop: 'plateNumber',
            width: 86,
            rules: [
              {
                required: true,
                message: '请输入车牌',
                trigger: 'blur',
              },
              {
                required: true,
                pattern: this.$validation.carPlate,
                message: '车牌格式不对',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '应收金额',
            prop: 'chargeTotal',
            width: 70,
          },
          {
            label: '优惠金额',
            prop: 'discountAmount',
            width: 70,
          },
          {
            label: '实收金额',
            prop: 'chargeAmount',
            width: 70,
          },
          {
            label: '入场时间',
            prop: 'inTime',
          },
          {
            label: '通道名称',
            search: true,
            prop: 'outPassageName',
          },
          {
            label: '出场时间',
            prop: 'outTime',
          },
          {
            label: '停车时长',
            prop: 'stopTime',
            width: 120,
          },
          {
            label: '是否付款',
            type: 'select',
            prop: 'payStatus',
            width: 70,
            dicData: [
              {
                label: '未付款',
                value: 0,
              },
              {
                label: '已付款',
                value: 1,
              },
              {
                label: '放弃付款',
                value: 2,
              },
            ],
          },
          {
            label: '付款时间',
            prop: 'payTime',
          },
          {
            label: '支付方式',
            prop: 'payType',
            width: 70,
          },
          {
            label: '操作人',
            prop: 'opeatorName',
            width: 70,
          },
          /*  {
            label: '是否平台付款',
            prop: 'payMethod',
            dicData: [
              {
                label: '否',
                value: 0,
              },
              {
                label: '是',
                value: 1,
              },
            ],
          },*/
          {
            label: '备注信息',
            prop: 'remark',
            width: 100,
            overHidden: false,
          },
          {
            label: '出场时间',
            prop: 'outTimeRange',
            searchslot:true,
            span: 24,
            search: true,
            searchRange: true,
            hide: true,
            display: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '入场时间',
            prop: 'inTimeRange',
            searchslot:true,
            searchSpan: 6,
            search: true,
            searchRange: true,
            hide: true,
            display: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '付款时间',
            prop: 'payTimeRange',
            searchslot:true,
            searchSpan: 6,
            search: true,
            searchRange: true,
            hide: true,
            type: 'daterange',
            display: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '应缴金额',
            prop: 'minMoney',
            hide:true,
            search:true,
            searchslot:true,
          },
          {
            label: '最大应缴',
            // search: true,
            hide:true,
            prop: 'maxMoney',
          },
          {
            label: '应缴总额',
            prop: 'chargeTotalSum',
            hide:true,
            search:true,
            searchslot:true,
          },
          {
            label: '实缴总额',
            prop: 'chargeAmountSum',
            hide:true,
            search:true,
            searchslot:true,
          },

        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.tempcarbill_add, false),
        viewBtn: this.vaildData(this.permission.tempcarbill_view, false),
        delBtn: this.vaildData(this.permission.tempcarbill_delete, false),
        editBtn: this.vaildData(this.permission.tempcarbill_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    getSpaceTree().then((data) => {
      this.parkingLotList = data.data;
      if (data.data.length > 0) {
        this.parkingLotId = this.parkingLotList[0].id;
      }
      this.onLoad();
    });
  },
  methods: {
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query.payNo = '';
      this.query.plateNumber =""
      this.query.outPassageName=''
      this.query.parkingLotId=''
      this.query.outTimeStart=""
      this.query.outTimeEnd=""
      this.query.inTimeStart=""
      this.query.inTimeEnd=""
      this.query.payTimeStart=""
      this.query.payTimeEnd=""
      this.minMoney=''
      this.maxMoney=''
      this.onLoad();
    },
    searchChange(params, done) {
      this.query.payNo = params.payNo;
      this.query.plateNumber = params.plateNumber;
      this.query.outPassageName = params.outPassageName;
      this.query.parkingLotId = params.parkingLotId;
      this.page.currentPage = 1;
      // if( this.vdui.isEmpty(this.query.outTimeStart)||this.vdui.isEmpty(this.query.outTimeEnd)){
      //   console.log("****")
      //   this.query.outTimeStart=''
      //   this.query.outTimeEnd=''
      // }
      // if( this.vdui.isEmpty(this.query.inTimeStart)||this.vdui.isEmpty(this.query.inTimeEnd)){
      //   console.log("****")
      //   this.query.inTimeStart=''
      //   this.query.inTimeEnd=''
      // }
      // if( this.vdui.isEmpty(this.query.payTimeStart)||this.vdui.isEmpty(this.query.payTimeEnd)){
      //   console.log("****")
      //   this.query.payTimeStart=''
      //   this.query.payTimeEnd=''
      // }
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      if (this.vdui.isEmpty(this.parkingLotId)) {
        this.loading = false;
        return;
      }
      this.query.parkingLotId = this.parkingLotId;
      this.query.minMoney = this.minMoney;
      this.query.maxMoney = this.maxMoney;
      page = page || this.page;
      this.loading = true;
      // if (this.query.outTimeRange) {
      //   this.query.outTimeStart = this.query.outTimeRange[0];
      //   this.query.outTimeEnd = this.query.outTimeRange[1];
      // }
      // if (this.query.inTimeRange) {
      //   this.query.inTimeStart = this.query.inTimeRange[0];
      //   this.query.inTimeEnd = this.query.inTimeRange[1];
      // }
      // if (this.query.payTimeRange) {
      //   this.query.payTimeStart = this.query.payTimeRange[0];
      //   this.query.payTimeEnd = this.query.payTimeRange[1];
      // }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          if(this.data[0]){
            this.chargeTotalSum = this.data[0].chargeTotalSum;
            this.chargeAmountSum = this.data[0].chargeAmountSum;
          }else{
            this.chargeTotalSum = 0.00;
            this.chargeAmountSum = 0.00;
          }
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>



<style scoped>
::v-deep .avue-crud__pagination {
  height:5vh!important;
}
::v-deep .avue-crud__search {
  height:18vh!important;overflow-y: scroll;
}
::v-deep .el-table {
  height:38vh!important;
}
::v-deep .avue-form__item-- {
  width:100%!important;
}
::v-deep .avue-form__menu--center {
    text-align: right;
}
</style>
